import React from "react";

const WatersVariantC = () => {
  return (
    <div className="space-y-5">
      {/* Headline */}
      <div>
        <h1 className="font-montserrat text-[28px] leading-tight font-bold text-gray-900">
          TWO REASONS WATERS CUSTOMERS LOVE THIS.
        </h1>
        <p className="text-base text-gray-600 mt-3">
          A smarter way to handle insurance — that actually pays you back.
        </p>
      </div>

      {/* Save Card */}
      <div className="bg-purpleMid rounded-2xl p-5">
        <p className="text-xs font-bold tracking-widest text-white/80 uppercase mb-1">
          Save on Insurance
        </p>
        <p className="font-montserrat text-4xl font-bold text-white">
          $1,000+<span className="text-lg font-normal text-white/70">/yr</span>
        </p>
        <p className="text-sm text-white/90 mt-2">
          Agencies compete for your verified profile — more competitive prices, no bait-and-switch quotes.
        </p>
      </div>

      {/* Earn Card */}
      <div className="bg-greenLight rounded-2xl p-5">
        <div className="flex items-center gap-2 mb-1">
          <p className="text-xs font-bold tracking-widest text-gray-900 uppercase">
            Earn from your data
          </p>
          <span className="bg-darkGreen text-gray-900 text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wide">
            First time ever
          </span>
        </div>
        <p className="font-montserrat text-4xl font-bold text-darkPurple">$3</p>
        <p className="text-sm text-gray-700 mt-2">
          Your insurance interest has always had value. Now that money comes to you — not Google or Meta.
        </p>
      </div>

      {/* Trust Badges */}
      <div className="flex gap-3">
        <div className="flex-1 bg-lightGrey rounded-xl px-3 py-3 text-center">
          <p className="text-xs text-gray-600">
            <span className="mr-1">⏱</span> ~5 minutes
          </p>
        </div>
        <div className="flex-1 bg-lightGrey rounded-xl px-3 py-3 text-center">
          <p className="text-xs text-gray-600">
            <span className="mr-1">🔒</span> No spam
          </p>
        </div>
        <div className="flex-1 bg-lightGrey rounded-xl px-3 py-3 text-center">
          <p className="text-xs text-gray-600">
            <span className="mr-1">✅</span> No obligation
          </p>
        </div>
      </div>
    </div>
  );
};

export default WatersVariantC;
